import PropTypes from 'prop-types';
import { extendObservable } from 'mobx';
import { apiCall } from '../../../API';
import FlagStore from '../../FlagStore';
import PolicyTableStore from '../PolicyTableStore';
import AccessCodeInfoStore from './AccessCodeInfoStore';

export const ACCESS_CODE_STATUS = {
    EXPIRED: 'expired',
    LIMIT_REACHED: 'limit_reached',
    PAUSED: 'paused',
    ACTIVE: 'active',
};

export default class AccessCodesStore {
    static PATH = '/console/policy_access_code'

    static PropType = PropTypes.shape({
        policyTable: PolicyTableStore.PropType.isRequired,
        aboutExpanded: FlagStore.PropType.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class AccessCodesStore */{
            policyTable: new PolicyTableStore({
                apiList: apiCall(`${AccessCodesStore.PATH}/list`),
                apiChangePriorities: apiCall(`${AccessCodesStore.PATH}/rearrange`),
                apiCreate: apiCall(`${AccessCodesStore.PATH}/create`),
                apiUpdate: apiCall(`${AccessCodesStore.PATH}/update`),
                apiDelete: apiCall(`${AccessCodesStore.PATH}/delete`),
                modalSections: {
                    info: new AccessCodeInfoStore(),
                },
                noHeader: true,
                preprocessHeaderValue: (v) => (v === null ? '' : v.code),
            }),
            aboutExpanded: new FlagStore(true),
        }, data);
    }
}
